<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div>
    <app-input-text (change)="onInput()" (input)="onInput()" (blur)="onInput()" [control]="form.get('account_holder')" name="payment_sepa_account" [autoFocus]="autoFocus"></app-input-text>
    <app-input-text (change)="onInput()" (input)="onInput()" (blur)="onInput()" [control]="form.get('acc_number')" name="payment_sepa_iban"></app-input-text>
    @if (bankAccount?.sddMandate?.identifier !== '') {
      <div>
        <label class="m-0" for="sdd_mandat_indentifier">{{ "sdd_mandate_identifier" | i18next }}</label>
        <div id="sdd_mandat_indentifier" class="p-inputtext border-0">{{ bankAccount.sddMandate.identifier }}</div>
      </div>
    }
  </div>
  @if (submitForm) {
    <app-button-submit [invalid]="form.invalid" [label]="submitLabel"></app-button-submit>
  }
</form>
